var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documentation-&-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/ConfigAPI",
    transform: "translate(-3.000000, -3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.687,2.99999697 C8.84719362,2.99867903 9.96641156,3.4289007 10.827,4.207 L10.834,4.213 L11.002,4.373 L13.238,6.609 C13.5163233,6.88869156 13.5605542,7.32515833 13.344,7.655 L13.322,7.684 L13.237,7.784 L12.637,8.384 L14.126,9.873 C14.4250873,10.1753457 14.4480148,10.6545765 14.1791573,10.984094 C13.9102998,11.3136116 13.4362175,11.3873258 13.08,11.155 L13.051,11.133 L12.951,11.048 L11.466,9.555 L9.815,11.207 L11.304,12.696 C11.5962209,12.999533 11.6154064,13.4736006 11.348669,13.7997547 C11.0819316,14.1259087 10.6134843,14.2011774 10.258,13.975 L10.229,13.953 L10.129,13.868 L8.639,12.383 L7.785,13.237 C7.50565877,13.5160627 7.06864681,13.5603489 6.739,13.343 L6.71,13.321 L6.61,13.236 L4.375,11.001 C3.03541892,9.66044119 2.6349556,7.64509119 3.36025073,5.89422786 C4.08554586,4.14336454 5.79385487,3.00157348 7.689,3.001 L7.687,2.99999697 Z M11.473,7.2 L9.825,5.549 C8.66647397,4.4095618 6.81456981,4.38940504 5.63151712,5.5033567 C4.44846443,6.61730836 4.35726341,8.46707529 5.425,9.692 L5.554,9.829 L7.197,11.475 L11.473,7.2 Z M16.803,10.523 C16.9658159,10.5226433 17.1251235,10.5702965 17.261,10.66 L17.29,10.682 L17.39,10.767 L19.626,13.003 C21.3739479,14.8080039 21.3876001,17.6702715 19.65695,19.4918673 C17.9262998,21.313463 15.0670835,21.446294 13.175,19.793 L13.168,19.787 L13,19.627 L10.764,17.391 C10.4856767,17.1113084 10.4414458,16.6748417 10.658,16.345 L10.68,16.316 L10.765,16.216 L16.218,10.763 C16.3727928,10.6071075 16.5833111,10.5193016 16.803,10.519 L16.803,10.523 Z M18.447,14.175 L16.803,12.531 L12.526,16.808 L14.175,18.451 C15.3293552,19.6033136 17.1895648,19.6325279 18.3795356,18.5170315 C19.5695064,17.4015351 19.6604099,15.5433182 18.585,14.317 L18.447,14.175 Z",
    id: "Shape_-_Outline"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiConfig);
export default __webpack_public_path__ + "static/media/api_config.55d66e1dd37903bd8004817e93483363.svg";
export { ForwardRef as ReactComponent };